const cargo = {
    name: "",
    typeId: "",
    comment: "",
    extendedProperties: [],
};

const distributionBidCargo = {
    name: "",
    typeId: "",
    comment: "",
};

export { cargo, distributionBidCargo };
